import {AxiosError} from 'axios';
import {toast} from 'react-toastify';

export const showRestError = (error: AxiosError | any) => {
    const message = error.response?.data?.message ?? error.message ?? error.detail;
    console.debug(error.status, error.code, error.message);
    console.error(error);
    toast.error(`${message}`, {autoClose: 5000});
};
